import React, { useState } from 'react';
import '../assets/styles/Sidebar.css';
import { FaBars, FaTimes, FaHome, FaWpforms, FaLink, FaSignOutAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  
  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  
  const handleNavigation = (path) => {
    navigate(path);
    setIsOpen(false);
  };
  
  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
    setIsOpen(false);
  };
  
  return (
    <div className={`sidebar-container ${isOpen ? 'open' : 'closed'}`}>
      <button className="toggle-button" type="button" onClick={toggleSidebar}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </button>
      <div className="sidebar-content">
        <ul>
          <li>
            <a onClick={() => handleNavigation('/main-user')}>
              <FaHome className="sidebar-icon" /> <span className="sidebar-text">Home</span>
            </a>
          </li>
          <li>
            <a onClick={() => handleNavigation('/manage-form')}>
              <FaWpforms className="sidebar-icon" /> <span className="sidebar-text">Create Your Form</span>
            </a>
          </li>
          <li>
            <a onClick={() => handleNavigation('/link-page')}>
              <FaLink className="sidebar-icon" /> <span className="sidebar-text">Access Your Links</span>
            </a>
          </li>
          <li>
            <a onClick={handleLogout}>
              <FaSignOutAlt className="sidebar-icon" /> <span className="sidebar-text">Logout</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;